import styled from 'styled-components'

import { ModalBodyContainer } from 'components/modal/styled'

export const ContestHeading = styled.dl`
  display: grid;
  grid-template-rows: auto auto;
  grid-auto-flow: column;
  row-gap: ${({ theme }) => theme.spacings[1.5]};

  margin-bottom: ${({ theme }) => theme.spacings[4]};
`

export const CustomDt = styled.dt`
  color: ${({ theme }) => theme.colors.warmGrey};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.10000000149011612px;
  text-align: left;
`

export const CustomDd = styled.dd`
  color: ${({ theme }) => theme.colors.greyishBrownFive};
  font-family: ${({ theme }) => theme.fonts.arial};
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.4399999976158142px;
  text-align: left;
`

export const ModalHeaderContent = styled.div`
  display: block;
  width: 100%;
`

export const ModalTitle = styled.label`
  margin-bottom: ${({ theme }) => theme.spacings[1]};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.bloggerSans};
  font-size: 34px;
  font-weight: 700;
  line-height: 37px;
  letter-spacing: 0.25px;
  display: block;
  width: 100%;
`

export const ModalSubtitle = styled.label`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: ${({ theme }) => theme.spacings[4]};
  font-family: ${({ theme }) => theme.fonts.bloggerSans};
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.15000000596046448px;
  text-align: center;
  display: block;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacings[6]};
`

export const ModalBody = styled(ModalBodyContainer)`
  & > button {
    margin: 0 auto;
  }
`
